import { useCallback, useRef } from 'react';

/**
 * Fecha um modal ao clicar no backdrop, sem fechar quando o usuário apenas
 * seleciona texto arrastando o mouse a partir de dentro do modal até soltar
 * fora dele — nesse caso o navegador dispara um `click` cujo alvo é o
 * próprio backdrop (ancestral comum do mousedown e do mouseup), então
 * checar só `e.target === e.currentTarget` no click não é suficiente.
 */
export function useBackdropClose(onClose: () => void) {
  const mouseDownNoBackdrop = useRef(false);

  const onMouseDown = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    mouseDownNoBackdrop.current = e.target === e.currentTarget;
  }, []);

  const onClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    if (mouseDownNoBackdrop.current && e.target === e.currentTarget) {
      onClose();
    }
    mouseDownNoBackdrop.current = false;
  }, [onClose]);

  return { onMouseDown, onClick };
}
